var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3482 20.1757L20.3351 21.0547L20.084 22.2184L21.4621 22.4726C22.3625 22.687 22.5401 23.0116 22.3441 23.9089L20.084 34.5297C19.4898 37.2767 20.4055 38.5691 22.5585 38.5691C24.2275 38.5691 26.1661 37.7974 27.045 36.7378L27.3145 35.4637C26.702 36.0028 25.8078 36.2171 25.2137 36.2171C24.3715 36.2171 24.0652 35.6261 24.2827 34.5848L27.3482 20.1757ZM27.5626 13.7812C27.5626 14.5935 27.2399 15.3724 26.6656 15.9468C26.0913 16.5211 25.3123 16.8438 24.5001 16.8438C23.6879 16.8438 22.9089 16.5211 22.3346 15.9468C21.7603 15.3724 21.4376 14.5935 21.4376 13.7812C21.4376 12.969 21.7603 12.1901 22.3346 11.6157C22.9089 11.0414 23.6879 10.7188 24.5001 10.7188C25.3123 10.7188 26.0913 11.0414 26.6656 11.6157C27.2399 12.1901 27.5626 12.969 27.5626 13.7812Z",
    fill: "#6B7A7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.959f5227101574b815410e9c20d78eed.svg";
export { ForwardRef as ReactComponent };